import type { App } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import routes from '@/router';
import { i18n } from '@/plugins/i18n';
import globalMiddleware from '@/middleware/globalMiddleware';

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, behavior: 'smooth' };
    }
  },
});

export default (app: App) => {
  const ogTitle = document.querySelector<HTMLMetaElement>(
    'meta[property="og:title"]',
  )!;
  const setTitle = (text: string) => {
    document.title = text;
    if (ogTitle) {
      ogTitle.content = text;
    }
  };

  router.afterEach(to => {
    const title = to?.meta?.title
      ? i18n.t(to?.meta?.title as string) + ' | KOOLING'
      : 'KOOLING';
    setTitle(title);
  });

  router.beforeEach(globalMiddleware);

  app.use(router);
};
